/** 插件名称与对其对应渠道的枚举 */
export var pluginChannelInfoMap = {
  StripeFpx: {
    channelId: 'Stripe',
    paymentMethod: 'FPX'
  }
};

/** 默认超时时间 */
export var DEFAULT_TIMEOUT = 10 * 1000;